<template>
  <div class="xqNews_detail">
    <!-- 新区要闻详情 -->
    <!-- 内容区 -->
    <div class="content">
      <div class="infoCon inner">
        <!-- 面包屑导航 -->
        <div class="mbnav">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">
              <img class="homeIcon" src="/statics/image/index/home.png" alt />
              首页
            </el-breadcrumb-item>
            <!-- <el-breadcrumb-item>
              <span @click="goback" v-if="catelist[nowIndex]">{{catelist[nowIndex].title}}</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>{{nowName}}</el-breadcrumb-item>
            </el-breadcrumb>-->
            <el-breadcrumb-item v-for="(item,index) in navList" :key="index">{{item.title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="title">
          <!-- <h3>{{articledetail.article_info?articledetail.article_info.title:""}}</h3> -->
          <h3 v-html="articleTitle"></h3>
          <div class="desc">
            <span>发布时间:{{articledetail.article_info?articledetail.article_info.publish_at:""}}</span>
            <span>发布人:{{articledetail.article_info?articledetail.article_info.admin.realname:""}}</span>
            <span>浏览量:{{articledetail.article_info?articledetail.article_info.hits:""}}</span>
          </div>
        </div>
        <!-- 新闻内容 -->
        <!-- <div class="newscom" v-html="articledetail.article_info.content"></div> -->
        <div class="newscom">
          <div class="conVideo" v-if="articledetail.article_info&&articledetail.article_info.video&&articledetail.article_info.video!=''" style="text-align:center;margin-bottom:0.2rem">
            <video
            :src="adddom(articledetail.article_info.video)"
            width="50%"
            height="100%"
            controls
          ></video>
          </div>
          <div class="fwb" v-html="content"></div>
          <a
            style="display:block"
            v-for="(item,index) in articledetail.article_info.funjianArr"
            :key="index"
            :href="$url+articledetail.article_info.funjianLinkArr[index]"
            class="fujian"
          >附件：{{item}}</a>
          <!-- <a
            :href="$url+articledetail.article_info.fujian"
            class="fujian"
            v-if="articledetail.article_info.fujian"
          >附件：{{articledetail.article_info.fujian_name}}</a>-->
        </div>
        <!-- 上一篇 -->
        <div class="pian">
          <div
            class="shang"
            @click="toPian(articledetail.last_article.article_id?articledetail.last_article.article_id:-1)"
          >
            上一篇：
            <span>{{articledetail.last_article.article_title?articledetail.last_article.article_title:'无'}}</span>
          </div>
          <div
            class="xia"
            @click="toPian(articledetail.next_article.article_id?articledetail.next_article.article_id:-1)"
          >
            下一篇：
            <span>{{articledetail.next_article.article_title?articledetail.next_article.article_title:'无'}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <!-- <index-footer></index-footer> -->
  </div>
</template>

<script>
// import indexTop from "./../components/top";
// import indexFooter from "./../components/footer";
export default {
  data() {
    return {
      articleTitle: "",
      navList: [],
      nowIndex: null,
      // nowId: null,
      // nowName: null,
      catelist: [],
      content: "", //富文本
      articledetail: {
        article_info: {
          title: "",
          publish_at: "",
          admin: {}
        },
        last_article: {}, //上一篇
        next_article: {} //下一篇
      }
    };
  },
  created() {
    this.getArticledetail();
    this.getNav();
    // this.wxShare();
  },
  // components: {
  //   indexTop,
  //   indexFooter
  // },
  // beforeRouteEnter(to, from, next) {
  //   //  修复iOS版微信HTML5 History兼容性问题
  //   // console.log("to.path",to.path);
    // console.log("location.pathname",location);
    // console.log("to",to);
  //   if (to.path !== location.pathname) {
  //     // 此处不可使用location.replace
  //     location.assign(to.fullPath);
  //   } else {
      // next();
  //   }
  // },
  methods: {
     // 图片拼接地址
    adddom(src) {
      if (src == "" || src == undefined || src == null) {
        console.log("src地址有问题");
        return "";
      }
      if (src.substr(0, 4).toLowerCase() === "http") {
        return src;
      }
      return this.$url + src;
    },
    wxShare() {
      var that = this;
      // console.log("分享内");
      // { url: shareUrl }
      const shareUrl = location.href.split("#")[0];
      // const shareUrl = location.href;
      // console.log("location.href",location.href);
      // console.log("shareUrl",shareUrl);
      that.$api.common.commonShare({ url: shareUrl }).then(res => {
        if (res.code == 200) {
          that.shareConfig = res.result;
          // console.log(that.shareConfig);
          wx.config({
            debug: that.shareConfig.debug,
            beta: that.shareConfig.beta,
            jsApiList: that.shareConfig.jsApiList,
            appId: that.shareConfig.appId,
            nonceStr: that.shareConfig.nonceStr, // 随机串
            timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
            signature: that.shareConfig.signature // 签名
          });
          // console.log('Iframe ---微信分享设置---开始');
          // 分享
          wx.ready(function() {
            var shareDataA = {
              title: that.articledetail.article_info
                ? that.articledetail.article_info.title
                : "河北衡水高新技术产业开发区管理管委会", // 分享标题
              desc: "河北衡水高新技术产业开发区管理管委会", // 分享描述
              link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: "http://www.hskfq.gov.cn/statics/image/wxshare.jpg", // 分享图标
              success: function() {},
              cancel: function(e) {}
            };
            var shareDataB = {
              title: that.articledetail.article_info
                ? that.articledetail.article_info.title
                : "河北衡水高新技术产业开发区管理管委会", // 分享标题
              link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: "http://www.hskfq.gov.cn/statics/image/wxshare.jpg", // 分享图标
              success: function() {},
              cancel: function(e) {}
            };
            // wx.onMenuShareAppMessage(shareDataA); //微信内分享
            wx.updateAppMessageShareData(shareDataA); // 分享给朋友
            wx.updateTimelineShareData(shareDataB); // 分享到朋友圈
            // console.log('Iframe ---微信分享设置---结束');
          });
        }
      });
    },
    getfu(str) {
      var res = str.split(",");
      var fu = [];
      for (var i in res) {
        fu.push(res[i]);
      }
      // this.fuList = res;
    },
    goback() {
      // this.$router.go(-1);
      // this.$router.push({
      //   path: "xqNews",
      //   query: {
      //     id: this.catelist[this.nowIndex].id,
      //     index: this.nowIndex
      //   }
      // });
    },
    getNav() {
      var that = this;
      that.nowIndex = that.$route.query.index;
      // that.nowId = that.$route.query.erId;
      that.$api.index.catelist({}).then(function(res) {
        if (res.code == 200) {
          that.catelist = res.result.all_cate;

          // var s_cates = that.catelist[that.nowIndex].s_cates;
          // for (var i in s_cates) {
          //   if (s_cates[i].id == that.nowId) {
          //     that.nowName = s_cates[i].title;
          //   }
          // }
        }
      });
    },
    getArticledetail() {
      var that = this;
      var ps = {
        cate_id: that.$route.query.cate_id,
        article_id: that.$route.query.id
      };
      that.$api.index.articledetail(ps).then(function(res) {
        if (res.code == 200) {
          that.articledetail = res.result;
          // console.log("分享外");
          that.wxShare();
          if (
            that.articledetail.article_info &&
            that.articledetail.article_info.title
          ) {
            // that.articleTitle = that.articledetail.article_info.title.replace("<br/>","");
            that.articleTitle = that.articledetail.article_info.title;
          }
          that.navList = res.result.catelist;
          var fujinNames = res.result.article_info.fujian_name;
          //   fujinNames = fujinNames.substring(0, fujinNames.lastIndexOf(','))
          // console.log("fujinNames", fujinNames);
          var funjianLinks = res.result.article_info.fujian;
          var funjianArr = [];
          var funjianLinkArr = [];
          if (fujinNames && fujinNames != undefined && fujinNames != "") {
            funjianArr = fujinNames.split(",").filter(item => item != "");
            funjianLinkArr = funjianLinks.split(",").filter(item => item != "");
            for (let i = 0; i < funjianLinkArr.length; i++) {
              const fujian = funjianLinkArr[i];
              // console.log(fujian)
              if (fujian.indexOf("upload") < 0) {
                funjianLinkArr[i] = "/upload/" + fujian;
              }
              // console.log(fujian)
            }
            // console.log(funjianLinkArr)
          }
          that.articledetail.article_info.funjianArr = funjianArr;
          that.articledetail.article_info.funjianLinkArr = funjianLinkArr;
          if (res.result.article_info && res.result.article_info.content) {
            that.content = res.result.article_info.content.replace(
              /\ src\=\"\upload/g,
              ' class="fupic" src="' + that.$url + "/upload"
            );
          } else {
            that.content = "";
          }
        }
      });
    },
    // 点击上下篇
    toPian(id) {
      if (id != -1) {
        this.$router.push({
          path: "/xqNews_detail",
          query: {
            cate_id: this.$route.query.cate_id,
            id: id,
            index: this.$route.query.index
          }
        });
      }
    }
  },
  mounted() {},
  watch: {
    $route(to, from) {
      this.getArticledetail();
    }
  }
};
</script>

<style>
.fwb table {
  float: none;
}
</style>